import Loading from "components/Loading";
import PageContent from "components/Page/Content";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { APP_URLS } from "settings";
import { useCaseStore } from "store/Case";
import StateContainer from "./StateContainer";

const FormSuccess = () => {
  const { caseId: urlCaseId } = useParams<{ caseId: string }>();
  const { setDebtConsolidationFormSubmitted } = useCaseStore();
  const navigate = useNavigate();

  useEffect(() => {
    setDebtConsolidationFormSubmitted(true);
    setTimeout(() => {
      navigate(APP_URLS.CASE_MANAGEMENT + "/" + urlCaseId);
    }, 1000);
  }, [urlCaseId, navigate, setDebtConsolidationFormSubmitted]);

  return (
    <PageContent padding={false}>
      <StateContainer>
        <Loading />
        <p className="mt-4">Submitting Debt Consolidation Form...</p>
      </StateContainer>
    </PageContent>
  );
};

export default FormSuccess;
